import { SystemField } from "./system-field";

export class ProductUom extends SystemField{
    
    code?:string;
    is_active?:number;
    desc?:string;
    note?:string;
    products_id?:string;
    to_unit?:string;
    from_unit?:string;
    conversion_method?:string;
    conversion_factor?:number;
    barcode?:string;
}
